module.exports = __webpack_public_path__ + "static/media/amazon-clone.2ce6c74e.png";